<a>
  <div class="container">
    <div class="izquierda">
      <h3>{{especialidad}}</h3>
      <p>{{nombreDoctor}}</p>
    </div>
    <div class="derecha">
      <h4>{{fecha}}</h4>
      <!-- <p>{{id}}</p> -->
    </div>
  </div>
</a>
